import PanelService from './PanelService';

export default PanelService;
